import Api from '@/services/Api'

export default {
  getInstallprices () {
    return Api().get('installprices/')
  },

  addInstallprice (installprice) {
    return Api().post('installprices/', installprice)
  },

  deleteInstallprice (id) {
    return Api().delete('installprice/' + id)
  },
  editInstallprice (id) {
    return Api().get('installprice/' + id)
  },
  updateInstallprice (installprice) {
    return Api().put('installprice/' + installprice.id, installprice)
  }
}



// WEBPACK FOOTER //
// ./src/services/InstallpriceService.js